import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useRouter } from "next/router";
import React, { useEffect } from "react";
import { Urls } from "../util/constant";
import { useAuth } from "./AuthProvider";
export function AuthGuard(_ref) {
  var children = _ref.children,
      _ref$LoaderComponent = _ref.LoaderComponent,
      LoaderComponent = _ref$LoaderComponent === void 0 ? function () {
    return /*#__PURE__*/_jsx("div", {
      children: "No Loader is specified"
    });
  } : _ref$LoaderComponent;

  var _useAuth = useAuth(),
      user = _useAuth.user,
      initializing = _useAuth.initializing,
      setRedirect = _useAuth.setRedirect;

  var router = useRouter();
  useEffect(function () {
    if (!initializing) {
      //auth is initialized and there is no user
      if (!user) {
        // remember the page that user tried to access
        setRedirect(router.route);
        router.push(Urls.LOGIN_URL);
      }
    }
  }, [initializing, router, user, setRedirect]);
  /* show loading indicator while the auth provider is still initializing */

  if (initializing) {
    return /*#__PURE__*/_jsx(LoaderComponent, {});
  } // if auth initialized with a valid user show protected page


  if (!initializing && user) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  }
  /* otherwise don't return anything, will do a redirect from useEffect */
  // return null; mostly works
  // TODO:Fix this


  return /*#__PURE__*/_jsx(LoaderComponent, {});
}